// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"2fb72a3c","433":"81b710ce"}[chunkId] + ".chunk.js";
};